/* eslint-disable */
export const ORDERS_ALL = `[ORDERS] ALL`;
export const ORDERS_ALL_COMPLETE = `[ORDERS] ALL COMPLETE`;
export const ORDERS_ALL_ERROR = `[ORDERS] ALL ERROR`;
export const ORDERS_ALL_SUCCESS = `[ORDERS] ALL SUCCESS`;

export const ORDERS_FIND_BY_ID = `[ORDERS] FIND BY ID`;
export const ORDERS_FIND_BY_ID_COMPLETE = `[ORDERS] FIND BY ID COMPLETE`;
export const ORDERS_FIND_BY_ID_ERROR = `[ORDERS] FIND BY ID ERROR`;
export const ORDERS_FIND_BY_ID_SUCCESS = `[ORDERS] FIND BY ID SUCCESS`;

export const ORDER_ID_UNSELECTED = `[ORDERS] ID UNSELECTED`;

export const ORDERS_ALL_ADDRESSES = `[ORDERS] ALL ADDRESSES`;
export const ORDERS_ALL_ADDRESSES_COMPLETE = `[ORDERS] ALL ADDRESSES COMPLETE`;
export const ORDERS_ALL_ADDRESSES_ERROR = `[ORDERS] ALL ADDRESSES ERROR`;
export const ORDERS_ALL_ADDRESSES_SUCCESS = `[ORDERS] ALL ADDRESSES SUCCESS`;

export const ORDERS_FIND_BY_STATUS = `[ORDERS] FIND BY STATUS`;
export const ORDERS_FIND_BY_STATUS_COMPLETE = `[ORDERS] FIND BY STATUS COMPLETE`;
export const ORDERS_FIND_BY_STATUS_ERROR = `[ORDERS] FIND BY STATUS ERROR`;
export const ORDERS_FIND_BY_STATUS_SUCCESS = `[ORDERS] FIND BY STATUS SUCCESS`;

export const ORDERS_CONFIRMATION = `[ORDERS] CONFIRMATION`;
export const ORDERS_CONFIRMATION_COMPLETE = `[ORDERS] CONFIRMATION COMPLETE`;
export const ORDERS_CONFIRMATION_ERROR = `[ORDERS] CONFIRMATION ERROR`;
export const ORDERS_CONFIRMATION_SUCCESS = `[ORDERS] CONFIRMATION SUCCESS`;

export const ORDERS_CANCELLATION = `[ORDERS] CANCELLATION`;
export const ORDERS_CANCELLATION_COMPLETE = `[ORDERS] CANCELLATION COMPLETE`;
export const ORDERS_CANCELLATION_ERROR = `[ORDERS] CANCELLATION ERROR`;
export const ORDERS_CANCELLATION_SUCCESS = `[ORDERS] CANCELLATION SUCCESS`;

export const ORDERS_FIND_LINKED = `[ORDERS] FIND LINKED`;
export const ORDERS_FIND_LINKED_COMPLETE = `[ORDERS] FIND LINKED COMPLETE`;
export const ORDERS_FIND_LINKED_ERROR = `[ORDERS] FIND LINKED ERROR`;
export const ORDERS_FIND_LINKED_SUCCESS = `[ORDERS] FIND LINKED SUCCESS`;
